import { SapBooleanEnum } from '@shared-enums/sap.enum';
import { TimesheetStatusEnum } from '@shared-enums/time.enum';
import { syncObjectProperties } from '@shared-helpers/array-object-helpers';
import { toTitleCase, trimLeadingZeros } from '@shared-helpers/string-number-helpers';
import { IExtDocument } from '@shared-interfaces/documents';

import { ApiService } from '../services/api.service';
import { ContractHandler } from './contracts';

export class ExtDocument {
  public Autocreate: boolean | '' = '';
  public CondGroup = '';
  public ContractDescription = '';
  public Costcenter1 = '';
  public Costcenter2 = '';
  public CustGroup = '';
  public Dateentered = '';
  public Description = '';
  public Documentno = '';
  public Genericfld01 = '';
  public Genericfld02 = '';
  public Genericfld03 = '';
  public Genericfld04 = '';
  public Genericfld05 = '';
  public Genericfld06 = '';
  public Genericfld07 = '';
  public Genericfld08 = '';
  public Genericfld09 = '';
  public Genericfld10 = '';
  public Nonbillable: SapBooleanEnum = SapBooleanEnum.False;
  public Owner = '';
  public Pernr = '';
  public Salesdoc = '';
  public Status = TimesheetStatusEnum.Created;
  public Timeentered = '';
  public Wbs = '';

  //tracked and calced

  __contractDetails: ContractHandler;
  display = '';

  constructor(sapData: IExtDocument | Record<string, unknown>, serviceOrder: ContractHandler) {
    syncObjectProperties(sapData, this, false);
    this.__contractDetails = serviceOrder;
    this.setDisplay();
    return this;
  }

  getContractDescription() {
    try {
      return this.__contractDetails.getDisplay();
    } catch (e) {
      console.error('Unable to get the display property from the contract', e);
      return '';
    }
  }

  setDisplay() {
    this.display = `#${trimLeadingZeros(this.Documentno)} `;
    if (this.Description) this.display += this.Description;
    else this.display += `Contract - ${this.getContractDescription()}`;
    this.display = toTitleCase(this.display);
  }

  getDisplay() {
    return this.display;
  }

  getServiceOrder() {
    return this.Salesdoc;
  }

  updateSelf(apiService: ApiService): void {
    apiService.updateExtDocument$(this.getSapObject()).subscribe();
  }

  getSapObject(): Partial<IExtDocument> {
    return {
      Owner: this.Owner,
      Description: this.Description,
      Status: this.Status,
      Autocreate: this.Autocreate ? SapBooleanEnum.True : SapBooleanEnum.False,
      Dateentered: this.Dateentered,
      Documentno: this.Documentno,
      Pernr: this.Pernr,
      Timeentered: this.Timeentered,
      Salesdoc: this.Salesdoc,
      Wbs: this.Wbs,
      CustGroup: this.CustGroup,
      CondGroup: this.CondGroup,
      Costcenter1: this.Costcenter1,
      Costcenter2: this.Costcenter2,
      Genericfld01: String(this.Genericfld01),
      Genericfld02: String(this.Genericfld02),
      Genericfld03: String(this.Genericfld03),
      Genericfld04: String(this.Genericfld04),
      Genericfld05: String(this.Genericfld05),
      Genericfld06: String(this.Genericfld06),
      Genericfld07: String(this.Genericfld07),
      Genericfld08: String(this.Genericfld08),
      Genericfld09: String(this.Genericfld09),
      Genericfld10: String(this.Genericfld10),
      Nonbillable: this.Nonbillable,
      ContractDescription: this.ContractDescription,
    };
  }
}
